/// <amd-module name="VSSUI/Components/DateTimePicker/DateTimePicker" />

import * as React from "react";
import { DatePicker } from "OfficeFabric/DatePicker";
import { FormItem } from "VSSUI/FormItem";
import { TextField } from "VSSUI/TextField";
import { warn } from "OfficeFabric/Utilities";
import * as Resources from "VSSUI/VSS.Resources.VSSUI";
import { IDateTimePickerProps } from "../../Components/DateTimePicker/DateTimePicker.Props";
import "VSS/LoaderPlugins/Css!VSSUI/Components/DateTimePicker/DateTimePicker";

/** @deprecated */
export interface DateTimePickerState {
    dateValue: string;
    dateErrorMessage: string;
}

/** @deprecated */
export class DateTimePicker extends React.Component<IDateTimePickerProps, DateTimePickerState> {
    private _value: Date = new Date();

    constructor(props: IDateTimePickerProps) {
        super(props);

        if (props) {
            if (!props.dateOnly) {
                if ("value" in props) {
                    warn(`'value' will be ignored. Use 'defaultValue'.`);
                }

                if ("onSelectDate" in props) {
                    warn(`'onSelectDate' will be ignored.`);
                }
            }

            this._value = props.defaultValue!;
            this.state = {
                dateValue: this.props.formatTime ? this.props.formatTime(this._value) : this._defaultFormatTime(this._value),
                dateErrorMessage: ""
            };
        }
    }

    public render(): JSX.Element {
        const { dateValue, dateErrorMessage } = this.state;
        if (this.props.dateOnly) {
            return <DatePicker aria-label={Resources.DateTimePicker_DateFieldAriaLabel} {...this.props} />;
        }
        return (
            <div className="vss-DateTimePicker">
                <div className="vss-DateTimePicker--dateField">
                    <DatePicker
                        className={this.props.dateFieldClassName}
                        isMonthPickerVisible={false}
                        {...this.props}
                        value={this._value}
                        ariaLabel={this.props.dateAriaLabel || Resources.DateTimePicker_DateFieldAriaLabel}
                        maxDate={this.props.maxDate}
                        minDate={this.props.minDate}
                        onSelectDate={(date: Date) => {
                            if (this._value) {
                                this._value.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
                            }
                            if (this.props.onValueChanged) {
                                this.props.onValueChanged(this._value);
                            }
                        }}
                    />
                </div>
                <div className="vss-DateTimePicker--timeField">
                    <FormItem className={this.props.timeFieldClassName} message={dateErrorMessage} error={dateErrorMessage !== ""}>
                        <TextField
                            value={dateValue}
                            onChange={this.onAdditionalInfoChange}
                            ariaLabel={this.props.timeAriaLabel || Resources.DateTimePicker_TimeFieldAriaLabel}
                        />
                    </FormItem>
                </div>
            </div>
        );
    }

    private onAdditionalInfoChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, newValue: string): void => {
        const { parseTimeFromString = this._defaultParseTimeFromString } = this.props;
        this.setState({
            dateValue: newValue,
            dateErrorMessage: this._getErrorMessage(newValue)
        });

        let parsedTime = parseTimeFromString(newValue);
        if (!!parsedTime) {
            this._value.setHours(parsedTime.getHours(), parsedTime.getMinutes(), parsedTime.getSeconds());
            if (this.props.onValueChanged) {
                this.props.onValueChanged(this._value);
            }
        }
    };

    private _getErrorMessage = (value: string): string => {
        const { parseTimeFromString = this._defaultParseTimeFromString } = this.props;
        return !!parseTimeFromString(value) ? "" : Resources.DateTimePicker_CannotParseTime;
    };

    private _defaultParseTimeFromString(timeStr: string): Date | null {
        const date = Date.parse(timeStr);
        if (date) {
            return new Date(date);
        }

        return null;
    }

    private _defaultFormatTime(date: Date): string {
        if (date) {
            return date.toLocaleTimeString();
        }

        return "";
    }
}
